import Chart from "react-apexcharts";
import React from "react";
const TransactionPerformance = ({ options, height = 350 }) => {
  return (
    <div id="chart">
      <Chart
        series={options.series}
        options={options.options}
        type="bar"
        height={height}
      />
    </div>
  );
};

export default TransactionPerformance;
